import React, { Component } from 'react';
import './styles.scss';
import { pageLoader } from '../../services/PageLoader';
import OrderDetailsPopover from '../OrderDetailsPopover';
import { Badge, CustomInput, FormGroup, Label, Pagination, PaginationItem, PaginationLink, Table } from 'reactstrap';
import Comment from '../Comment';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { UAH } from '../../filters';

export default class OrderList extends Component {
  state = {
    loading: false
  };

  constructor(props) {
    super(props);

    setTimeout(() => {
      pageLoader.stop();
    }, 5000);
  }

  onClick() {
    pageLoader.start();
  }

  render() {
    return (
      <>
        <Table size="sm" striped className={`order-table table-wrapper-scroll-y ${this.state.loading && '__skeleton'}`}>
          <thead>
          <tr>
            <th>ID</th>
            <th>Поставщик</th>
            <th>Получатель</th>
            <th>Контакты</th>
            <th>Оплата</th>
            <th>ТТН</th>
            <th>Статус</th>
            <th>Сумма</th>
            <th>Выплата</th>
            <th></th>
            <th>Дата</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="1"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="warning">Отправлен</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever "/></td>
            <td className="text-nowrap">1.8.18</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="2"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="warning">Отправлен</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="3"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="primary">Доставлен</Badge></td>
            <td>{UAH(200)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="4"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td><i className="text-muted">самовывоз</i></td>
            <td>–</td>
            <td><Badge color="secondary">Ожидается</Badge></td>
            <td>{UAH(300)}</td>
            <td>Да</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="5"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="success">Получен</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="6"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="danger">Отменен</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="7"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>
              <span>На карту</span>
              &nbsp;
              <FontAwesomeIcon icon={faCheck} size="sm" color="green"></FontAwesomeIcon>
            </td>
            <td>20342234412321</td>
            <td><Badge color="warning">Отправлен</Badge></td>
            <td>{UAH(800)}</td>
            <td>–</td>
            <td><Comment text="Shot comment"/></td>
            <td className="text-nowrap">5.12.19</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="8"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="warning">Отправлен</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.20</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="9"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="light">Обработка</Badge></td>
            <td>{UAH(800)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.20</td>
          </tr>
          <tr>
            <td scope="row" onClick={() => this.onClick()}><OrderDetailsPopover id="10"/></td>
            <td>DropSpot</td>
            <td className="text-nowrap">Антон Роженко</td>
            <td className="text-nowrap">(093)547-2149</td>
            <td>Наложенным</td>
            <td>20342234412321</td>
            <td><Badge color="light">Обработка</Badge></td>
            <td>{UAH(100)}</td>
            <td>Нет</td>
            <td><Comment text=""/></td>
            <td className="text-nowrap">5.12.20</td>
          </tr>
          </tbody>
        </Table>

        <div className="clearfix">
          <Pagination className="float-left">
            <PaginationItem active>
              <PaginationLink href="#">1</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">2</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">3</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">4</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">5</PaginationLink>
            </PaginationItem>
          </Pagination>

          <FormGroup className="per-page">
            <Label for="exampleCustomSelect" hidden>Custom Select</Label>
            <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
              <option disabled>Показывать на странице</option>
              <option value="">10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </CustomInput>
          </FormGroup>
        </div>
      </>
    );
  }
}
